export const RFD_HUD_COMPASS_ID = "$$rfd-hud-compass";
